import React from 'react';
import { MapCard } from './MapCard';
import { ReportCard } from './ReportCard';
import { CoursePlanCard } from './CoursePlanCard';
import type { LexceCard } from '../../types/lexce';
interface CardRendererProps {
  card: LexceCard;
}
export function CardRenderer({
  card
}: CardRendererProps) {
  if (card.type === 'map') return <MapCard card={card} data-id="element-26" data-mp="1qv6r3dgvwprh" />;
  if (card.type === 'report') return <ReportCard card={card} data-id="element-27" data-mp="1cx010ji6fu2d" />;
  return <CoursePlanCard card={card} data-id="element-28" data-mp="1cvozyrg490ey" />;
}